import { forwardRef } from 'react';
import { Typography, Box, styled, classes } from 'bonfire-kindling';

const StyledBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'isSelected' && prop !== 'isFocused',
})(({ theme, isSelected, isFocused }) => ({
  [`& .${classes.components.MuiTypography.root}`]: {
    fontWeight: isSelected ? 'bold' : 'normal',
    color: isSelected ? theme.palette.primary.main : theme.palette.brand.grey.charcoal,
  },
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  [theme.breakpoints.up('lg')]: {
    width: '400px',
  },
  [theme.breakpoints.down('lg')]: {
    width: '350px',
  },
  boxShadow: isFocused
    ? `0 0 0 2px ${theme.palette.focusRing.main}, 1px 2px 3px 1px ${theme.palette.focusRing.main}`
    : 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '1.125rem 2rem',
  flex: '1 1 0%',
  margin: 0,
  cursor: 'pointer',
  userSelect: 'none',
  textDecoration: 'none',
  position: 'relative',
  overflow: 'hidden',
  whiteSpace: 'normal',
  backgroundColor: theme.palette.common.white,
  borderColor: isSelected ? theme.palette.primary.main : 'transparent',
  borderRadius: 8,
  borderWidth: '2px',
  borderStyle: 'solid',
  outline: 'none',
}));

const SavedSearchSettingsUpsertTab = forwardRef(
  ({ title, description, className, ...props }, ref) => {
    const isFocused = className.includes(classes.states.MuiFocusVisible);
    const isSelected = className.includes(classes.states.MuiSelected);

    return (
      <Box
        sx={{
          '&:not(:first-child)': {
            mt: 4,
          },
          '&:focus-visible': {
            outline: 'none',
          },
          display: 'flex',
          flexDirection: 'column',
          px: 1,
        }}
        {...props}
        ref={ref}
      >
        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 3 }}>
          {title}
        </Typography>
        <StyledBox isSelected={isSelected} isFocused={isFocused}>
          <Typography variant="body2">{description}</Typography>
        </StyledBox>
      </Box>
    );
  }
);

export default SavedSearchSettingsUpsertTab;
